export default "__VITE_ASSET__BY3imYJn__"